/* global messg */
import React, { useState } from 'react'
import { useValues, useActions } from 'kea'

import I18n from 'lib/i18n'
import FullOverlay from 'lib/components/full-overlay'
import { getSharePayload } from 'lib/utils/courses/share'
import ClickOutside from 'lib/tags/click-outside'
import Close from 'lib/icons/close'

import courseLogic from '~/scenes/course/show/logic'

export default function SharingMenu () {
  const {
    course: { shareUrl, title },
    facebookApp
  } = useValues(courseLogic)

  const { disableSharing } = useActions(courseLogic)
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(null)

  const share = (event, type) => {
    event.preventDefault()
    window.open(...getSharePayload(type, shareUrl, title, facebookApp))
  }

  const copyLink = async event => {
    event.preventDefault()
    try {
      // auto copy
      const response = await navigator.clipboard.writeText(window.location.href)
      if (response) {
        messg.success(I18n.t('courses.show.link_copied'), 1500)
      }
    } catch (error) {
      // just display url to copy
      setIsLinkModalOpen(window.location.href)
    }
  }

  const emailLink = `mailto:?subject=${I18n.t('courses.show.mail_subject')}&body=${I18n.t(
    'courses.show.mail_body'
  )} ${shareUrl}`

  return (
    <div>
      <FullOverlay />
      <ClickOutside onClickOutside={disableSharing}>
        <div className='sharing-popup'>
          <Close style={{ background: '#fff' }} pathStyle={{ stroke: '#222' }} onClick={disableSharing} />
          <div className='sharing-content'>
            <ul>
              <li>
                <h3>{I18n.t('courses.show_share.email_share_title')}</h3>
              </li>
              <li key='share-email'>
                <a href={emailLink} target='_blank' rel='noreferrer'>
                  {I18n.t('activerecord.attributes.user.email')}
                </a>
              </li>
              {['messenger', 'whatsapp', 'facebook', 'twitter', 'linkedin'].map(sm => (
                <li key={`share-${sm}`} onClick={e => share(e, sm)}>
                  <a>{I18n.t(`courses.show.share_service.${sm}`)}</a>
                </li>
              ))}
              <li key='share-copy-link' onClick={copyLink}>
                <a>{I18n.t('courses.show.copy_link')}</a>
              </li>
            </ul>
            {isLinkModalOpen && <input className='link-to-copy-input' onFocus={copyLink} value={isLinkModalOpen} />}
          </div>
        </div>
      </ClickOutside>
    </div>
  )
}
